import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fe3f9b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password_reset_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "password_reset_title" }, "パスワード再設定完了", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "password_reset_text" }, "新しいパスワードでログインしてください", -1))
const _hoisted_4 = { class: "password_reset_button_login" }
const _hoisted_5 = { class: "password_reset_button_top" }

import BaseButton from '@/components/BaseButton.vue';
import LinkToTopButton from '@/components/LinkToTopButton.vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetComplete',
  setup(__props) {

const router = useRouter();

const forwardToLogin = () => {
  router.push({ name: 'a10' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseButton, {
          theme: "primary",
          onClick: forwardToLogin
        }, {
          default: _withCtx(() => [
            _createTextVNode("ログイン")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(LinkToTopButton)
      ])
    ])
  ]))
}
}

})